import React, { useState, useEffect } from "react";
import phonology from "assets/images/phonology.png";
import InstagramLogo from "assets/images/instagram.svg";
import WhatsAppLogo from "assets/images/whatsapp.svg";
import banner from "assets/images/banner.png";
import "./ShopInfo.css";
import { NavLink } from "react-router-dom";
import EditShopInfoModal from "../EditShopInfoModal";
const ShopInfo = ({ data, shopInfoUpdater, setShopInfoUpdater, adminId }) => {
  const shopinfo = data;
  console.log(data, "data in shop info");
  return (
    <div className="container-fluid position-relative p-0">
      {shopinfo.cover ? (
        <div className="banner" style={{ width: "100%" }}>
          <img src={shopinfo.cover} alt=" " style={{ width: "100%" }} />
        </div>
      ) : (
        <div className="banner1" style={{ width: "100%" }}></div>
      )}

      <div className="d-flex flex-column justify-content-between align-items-center gap-5 mt-3 ">
        <div className="d-flex justify-content-center align-items-center">
          {shopinfo.logo != "" ? (
            <img
              className="rounded-pill"
              style={{
                width: "180px",
                height: "140px",
                borderRadius: "50%",
                zIndex: 1,
                backgroundColor: "white",
              }}
              src={shopinfo.logo}
              // className="rounded-pill"
            />
          ) : (
            <div
              style={{
                width: "180px",
                height: "140px",
                borderRadius: "50%",
                zIndex: 1,
              }}
            ></div>
          )}
        </div>
        <div className="d-flex flex-column align-items-center  text-center">
          {shopinfo.shopname && (
            <span
              style={{ borderRadius: "12px", padding: "5px 15px 8px 15px" }}
              className="bg-light"
            >
              {shopinfo.shopname}
            </span>
          )}
          {/* <EditShopInfoModal
            adminId={adminId}
            data={shopinfo}
            type={shopinfo.type}
            shopInfoUpdater={shopInfoUpdater}
            setShopInfoUpdater={setShopInfoUpdater}
          /> */}
        </div>
        <div className="d-flex justify-content-evenly w-75 align-items-start bg-light rounded-pill text-center py-4 shadow flex-column flex-sm-row">
          <div className="col-12 col-sm-7 mx-auto pt-2 d-flex justify-content-center align-items-center flex-column gap-2 px-5 ">
            <span className="fw-bold">آدرس</span>
            <span>
              {shopinfo.address != ""
                ? shopinfo.address
                : "در حال حاضر آدرسی برای فروشگاه ثبت نشده است."}
            </span>
          </div>
          <div
            id="socialmedia"
            className="col-12 col-sm-5 mx-auto pt-2 d-flex flex-column justify-content-center align-items-center gap-2 px-5 "
          >
            <span className="fw-bold">شبکه های اجتماعی</span>
            <div className="d-flex flex-column  flex-wrap justify-content-center">
              {
                <div className="d-flex flex-row gap-2">
                  <img src={InstagramLogo} />
                  {shopinfo.instagramaddress ? (
                    <a
                      href={
                        "https://instagram.com/" + shopinfo.instagramaddress
                      }
                      target="_blank"
                      className="mx-auto"
                    >
                      <span>{shopinfo.instagramaddress}</span>
                    </a>
                  ) : (
                    "-------"
                  )}
                </div>
              }
              {
                <div className="d-flex gap-2">
                  <img src={WhatsAppLogo} />
                  {shopinfo.whatsappaddress ? (
                    <a
                      href={"https://wa.me//" + shopinfo.whatsappaddress}
                      target="_blank"
                      className="mx-auto"
                    >
                      <span>{shopinfo.whatsappaddress}</span>
                    </a>
                  ) : (
                    "-------"
                  )}
                </div>
              }
            </div>
          </div>
          {/* <div
            className="col-12 col-sm-4
          d-flex flex-column justify align-items-center gap-2 px-5 "
          >
            <span className="fw-bold">امتیاز فروشگاه</span>
            <span
              className={`fs-1 fw-bold ${shopinfo.rate <= 1 && "text-danger"} ${
                shopinfo.rate <= 3 ? "text-warning" : "text-success"
              }`}
            >
              {shopinfo.rate}
            </span>
          </div> */}
        </div>
      </div>
    </div>
  );
};

export default ShopInfo;
